import Repository from "@/repositories/Repository";

// Verb 	    URI 	                Action 	  Route Name
// GET 	      /photos 	            index 	  photos.index
// GET 	      /photos/create 	      create 	  photos.create
// POST 	    /photos 	            store 	  photos.store
// GET 	      /photos/{photo} 	    show 	    photos.show
// GET 	      /photos/{photo}/edit 	edit 	    photos.edit
// PUT/PATCH 	/photos/{photo} 	    update 	  photos.update
// DELETE 	  /photos/{photo} 	    destroy 	photos.destroy

const resource = "/zurich";

export default {
    zurich_avail_methods() {
        return Repository.get(`${resource}/available-payment-method`);
    },
    create_ancillary(payload) {
        // create a new insurance_ancillary
        return Repository.post(`${resource}/create-ancillary`, payload);
    },
    create_deferred(payload) {
        // create a new deferred
        return Repository.post(`${resource}/create-deferred-book-entry`, payload);
    },
};